import React, { Dispatch, SetStateAction } from 'react';
import { NumericFormat } from 'react-number-format';

import {
  DEFAULT_QUOTE_REFETCH_INTERVAL,
  MAX_DECIMALS,
} from '@magic-swap/components/pages/MagicSwap/constants';
import { SwapState } from '@magic-swap/components/pages/MagicSwap/types';

export interface SwapAmountInputProps {
  stringFromAmount: string;
  setFromAmount: (s: string) => void;
  swapState: SwapState;
  setSwapState: Dispatch<SetStateAction<SwapState>>;
}

const SwapAmountInput = ({
  stringFromAmount,
  setFromAmount,
  swapState,
  setSwapState,
}: SwapAmountInputProps) => {
  return (
    <NumericFormat
      className="my-2 t-h3 max-sm:text-[16px] bg-transparent outline-none text-right w-full overflow-auto"
      allowNegative={false}
      thousandSeparator
      decimalScale={MAX_DECIMALS}
      value={stringFromAmount}
      max={Number.MAX_SAFE_INTEGER}
      isAllowed={(values) => {
        // Directly return true for "0" or "0." followed by digits to allow these specific cases.
        if (!values.floatValue && !values.value) {
          return true;
        }

        const newAmount = Number(values.value);
        const maxAmount = Number.MAX_SAFE_INTEGER;

        if (newAmount > maxAmount) {
          setFromAmount(String(maxAmount));
          return false;
        }

        // Use a regex to ensure the number does not start with "0" followed by any other digit unless it's "0.".
        // This effectively disallows leading zeros for numbers greater than "0."
        const isValidFormat = /^(0|[1-9]\d*)(\.\d*)?$|^\.\d+$/;
        return isValidFormat.test(values.value);
      }}
      onValueChange={(values, info) => {
        if (info.source === 'prop') {
          return;
        }

        setFromAmount(values.value);

        if (swapState.isUsingMax) {
          setSwapState((prev) => ({
            ...prev,
            isUsingMax: false,
            quoteRefetchInterval: DEFAULT_QUOTE_REFETCH_INTERVAL,
          }));
        }
      }}
      placeholder="0.00"
    />
  );
};

export default SwapAmountInput;
